import React from 'react'
import { ApiClientProviderV2 } from '@chilipiper/api-client/src/context'
import { getApiV2Config } from '@chilipiper/service/src/apiClientConfig'

const apiConfig = getApiV2Config()

export const ApiClientProvider = ({ children }: { children?: React.ReactNode }) => {
  return <ApiClientProviderV2 apiConfig={apiConfig}>{children}</ApiClientProviderV2>
}
